import { lazy } from 'react';

export const EditModal = lazy(() => import('./EditModal'));
